import { esCrafterXb } from '../../../common/EsCrafter';

/* A page's heading and blurb, as EsLegal opens: es-<slug>-heading and es-<slug>-blurb. */
export default function EsBlockHeading( { slug, block, item } ) {
    return (
        <>
            <h3 data-testid={ `es-${ slug }-heading` } className="mb-3 text-center text-2xl font-bold text-heading sm:text-3xl"
                { ...esCrafterXb( item, block, 'title_s' ) }>
                { block.title_s }
            </h3>
            { block.blurb_t && (
                <p data-testid={ `es-${ slug }-blurb` } className="mb-10 text-center opacity-70" { ...esCrafterXb( item, block, 'blurb_t' ) }>
                    { block.blurb_t }
                </p>
            ) }
        </>
    );
}
